import { render, staticRenderFns } from "./crossCheckAiOcrMultiDetail.vue?vue&type=template&id=2716be1a&scoped=true&"
import script from "./crossCheckAiOcrMultiDetail.vue?vue&type=script&lang=js&"
export * from "./crossCheckAiOcrMultiDetail.vue?vue&type=script&lang=js&"
import style0 from "./crossCheckAiOcrMultiDetail.vue?vue&type=style&index=0&id=2716be1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2716be1a",
  null
  
)

export default component.exports